import {ProcessCloseConfirmationComponent} from './process-close-confirmation.component'
import {take} from 'rxjs/operators'
import {DialogService} from '../../../craft/dialog/dialog.service'
import {LinkService} from '../../../core/i18n/link.service'
import {Injectable} from '@angular/core'
import {ApplicationRoute} from '../../../craft/utils/application.route'
import {JobRequestService} from '../../../pages/public/job-request-page/job-request.service'

@Injectable()
export class ProcessService {
  constructor(
    private readonly dialogService: DialogService,
    private readonly linkService: LinkService,
    private readonly jobRequestService: JobRequestService,
  ) {}

  close(exitButtonText: string): void {
    this.dialogService
      .show(ProcessCloseConfirmationComponent, exitButtonText)
      .closed.pipe(take(1))
      .subscribe(result => {
        if (result) {
          const target = this.jobRequestService.referrerPage() || this.linkService.homePath
          this.linkService.navigateTo(new ApplicationRoute(target))
        }
      })
  }
}
